import BlockDetails from "./BlockDetails";
export default BlockDetails;
